import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { Button, Row, Col } from 'reactstrap';
import { Link } from 'client/site-modules/shared/components/link/link';

import './calculator-section.scss';

export function CalculatorSection({ url, title, subtitle, isLast = false, button }) {
  const { text, trackingId } = button;

  return (
    <Fragment>
      <Row className="calculator-section">
        <Col xs={12} md={6}>
          <Link className="text-primary-darker heading-4 fw-bold" to={url}>
            {title}
          </Link>
          <div className="calculator-subtitle mt-0_5">{subtitle}</div>
        </Col>
        <Col xs={12} md={6} className="align-self-center text-md-end mt-1 mt-md-0">
          <Button
            tag={Link}
            to={url}
            name={text}
            outline
            color="blue-50"
            size="md"
            className="text-transform-none"
            data-tracking-id={trackingId}
          >
            <span className="fw-medium size-16">{text}</span>
          </Button>
        </Col>
      </Row>
      {!isLast && <hr className="my-1_5" />}
    </Fragment>
  );
}

CalculatorSection.propTypes = {
  url: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string.isRequired,
  isLast: PropTypes.bool,
  button: PropTypes.shape({
    text: PropTypes.string,
    trackingId: PropTypes.string,
  }).isRequired,
};
